import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { Subject } from "rxjs";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { CommonModule, DatePipe } from "@angular/common";
import { BuyerComponent } from "../../components/buyer/buyer.component";
import { CustomerAccountComponent } from "../../components/customer-account/customer-account.component";
import { ActivatedRoute, Router } from "@angular/router";
import { AddClientContact } from "../../../../core/models/client/addClientContact";
import { CustomerPaymentMethodDto } from "../../../../core/models/orders/customerPaymentMethodDto";
import { ProgramClientListDto } from "../../../../core/models/program/programClientListDto";
import { ClientSearchList } from "../../../../core/models/shared/clientSearchList";
import { DatePickerModule } from "primeng/datepicker";
import { TableModule } from "primeng/table";
import { Popover, PopoverModule } from "primeng/popover";
import { GetBCForSalesOrderDto } from "../../../../core/models/orders/getBCForSalesOrderDto";
import { GetBacForSalesOrderDto } from "../../../../core/models/orders/getBacForSalesOrderDto";
import { SelectModule } from "primeng/select";
import { InputTextModule } from "primeng/inputtext";
import { DropdownModule } from "primeng/dropdown";
import { AddContactInformationComponent } from "../../../clients/components/add-contact-information/add-contact-information.component";
import { ProgramComponent } from "../../../clients/components/program/program.component";
import { ProgramListDto } from "../../../../core/models/program/programListDto";
import { computeMinDate } from "../../../../core/utilities/mindate-function";
import { InventoryLookupService } from "../../../../core/services/inventory-lookup.service";
import {
  InventoryOwnerDto,
  InventoryWarehouseDto,
  JniStoreDto,
} from "../../../../core/models/inventory/inventory-lookup.models";

@UntilDestroy()
@Component({
  selector: "jni-order-header",
  templateUrl: "./order-header.component.html",
  styleUrls: ["./order-header.component.scss"],
  providers: [DatePipe],
  imports: [
    CustomerAccountComponent,
    BuyerComponent,
    CommonModule,
    DatePickerModule,
    SelectModule,
    TableModule,
    ReactiveFormsModule,
    PopoverModule,
    InputTextModule,
    DropdownModule,
    AddContactInformationComponent,
    ProgramComponent,
  ],
})
export class OrderHeaderComponent implements OnInit {
  public customerVendor$ = new Subject<string>();
  //customerLists: any[] = [];
  showSmallLoader = false;
  inHandDate!: string;
  shipDate!: string;
  brandingConsultantObject!: GetBCForSalesOrderDto;
  shipDateCurrentdate = computeMinDate();
  shipDateCurrentdate2 = computeMinDate();
  inHandDateCurrentdate = computeMinDate();
  date1 = new Date();
  customerAccountNumber = "";
  addClientContact: AddClientContact = {} as AddClientContact;
  displayAddContact = false;
  programId = 0;
  programName = "";
  sharedMonthForView = new Date();

  storeList: JniStoreDto[] = [];
  warehouseList: InventoryWarehouseDto[] = [];
  ownerList: InventoryOwnerDto[] = [];
  ownerDisabled = true;

  @Input() parent!: FormGroup;
  @Input() bacUserDefaultSelectionId = "";
  @Input() bacList: GetBacForSalesOrderDto[] = [];
  @Input() brandingConsultantLists: GetBCForSalesOrderDto[] = [];
  @Input() deliveryAddress: {
    id: number;
    name: string;
    status: boolean;
  }[] = [];
  @Input() formErrors!: Record<string, string>;
  @Input() customerPaymentMethodList: CustomerPaymentMethodDto[] = [];
  @Input() customerBillToObject!: ClientSearchList;
  @Input() orderType = "";
  @Input() newSalesOrderCase = false;

  // customerBillToObjectNew!:clientSearchList;

  @Output() bcSelectionEvent = new EventEmitter<string>();
  @Output() customerBillToObjectEvent = new EventEmitter();
  @Output() validationErrorEvent = new EventEmitter();
  @Output() smallLoaderEvent = new EventEmitter();
  @Output() clearShipToEvent = new EventEmitter();
  @Output() contactListRefreshGrid = new EventEmitter();
  @Output() programDetailsEvent = new EventEmitter<ProgramClientListDto>();
  @Output() customerAccountChangedEvent = new EventEmitter<string>();
  @Output() buyerChangeEvent = new EventEmitter<void>();
  @Output() patchValueInCurrencyField = new EventEmitter<string>();
  applyCreditCardStatus = true;

  @ViewChild("buyer", { static: false })
  buyer!: BuyerComponent;

  @ViewChild("program", { static: false })
  program!: ProgramComponent;

  @ViewChild("buyer", { static: false })
  customerAccount!: CustomerAccountComponent;

  constructor(
    public datepipe: DatePipe,
    private route: Router,
    private activeRoute: ActivatedRoute,
    private _inventoryLookupService: InventoryLookupService
  ) {
    const nav = this.route.getCurrentNavigation();
    if (nav?.extras?.state?.["orderType"]) {
      this.orderType = nav.extras.state["orderType"];
    } else {
      this.activeRoute.queryParams.subscribe(params => {
        if (params["module"]) {
          this.orderType = params["module"];
        }
      });
    }
  }

  ngOnInit() {
    if (this.orderType === "inventory-sales") {
      this.loadInventoryLookups();
    }
  }

  onShipDateSelection(event: Date) {
    //this.shipDate = new Date(event).toLocaleDateString();
    const date = new Date(event);
    this.sharedMonthForView = date;

    this.shipDate = this.datepipe.transform(date, "MM/dd/yyyy") ?? "";
    if (this.shipDate) {
      this.inHandDateCurrentdate = computeMinDate(this.shipDate, false);
    } else {
      this.inHandDateCurrentdate = computeMinDate();
    }
    this.parent.patchValue({
      orderHeader: {
        shipDate: this.shipDate,
      },
    });
  }

  onInHandDateSelection(event: Date) {
    //this.inHandDate = new Date(event).toLocaleDateString();
    const date = new Date(event);
    this.inHandDate = this.datepipe.transform(date, "MM/dd/yyyy") ?? "";
    this.parent.patchValue({
      orderHeader: {
        inHandsDate: this.inHandDate,
      },
    });
  }

  onBrandingConsultantSelection(mouseEvent: MouseEvent, dropdown: Popover) {
    this.showSmallLoader = true;
    dropdown.show(mouseEvent);
  }

  onProjectIdSelection(event: GetBCForSalesOrderDto, dropdown: Popover) {
    this.brandingConsultantObject = event;

    this.bcSelectionEvent.emit(event.personnelNumber);
    this.patchProjectIdInBCField(event);
    dropdown.hide();
  }

  patchProjectIdInBCField(event: GetBCForSalesOrderDto) {
    this.parent.patchValue({
      orderHeader: {
        brandingConsultant: event.projectName,
      },
    });
  }

  getAllBuyers() {
    this.buyer.getAllBuyers();
  }

  getAllProgramByCustomerAccount(customerAccount: string) {
    this.program.getAllProgramDetailsByCustomerAccount(customerAccount, true);
    this.customerAccountChangedEvent.emit(customerAccount);
  }

  getCustomerBillToData(clientObj: ClientSearchList) {
    this.customerAccountNumber = clientObj.clientAccount;
    this.customerBillToObjectEvent.emit(clientObj);
    if (this.orderType === "inventory-sales") {
      this.onInventoryCustomerDefaults(clientObj);
    }
  }

  logValidationErrors() {
    this.validationErrorEvent.emit();
  }

  getLoaderStatus(status: boolean) {
    this.smallLoaderEvent.emit(status);
  }

  clearShipToForm() {
    this.clearShipToEvent.emit();
  }

  getCreditCard(event: Event) {
    const target = event.target as HTMLSelectElement;
    if (target?.value === "CC") {
      this.applyCreditCardStatus = false;
    } else {
      this.applyCreditCardStatus = true;
    }
  }

  addContactInformation() {
    const getBuyerValue = this.parent.get(["orderHeader", "buyer"])
      ?.value as string;
    if (this.customerBillToObject?.clientAccount && getBuyerValue) {
      const getSplitValues = getBuyerValue.split(" ");
      this.customerAccountNumber = this.customerBillToObject.clientAccount;
      this.addClientContact.firstName = getSplitValues[0] ?? "";
      this.addClientContact.lastName = getSplitValues[1] ?? "";
      this.addClientContact.type = "Buyer";
    } else {
      this.customerAccountNumber = this.customerBillToObject.clientAccount;
      this.addClientContact.firstName = "";
      this.addClientContact.lastName = "";
      this.addClientContact.type = "Buyer";
    }
    this.displayAddContact = true;
  }

  isContactAdded(obj: boolean) {
    if (obj) {
      this.contactListRefreshGrid.emit(true);
      this.buyerChangeEvent.emit();
    }
  }

  populateContactAddedInfo(obj: string) {
    if (obj) {
      this.parent.patchValue({
        orderHeader: {
          buyer: obj,
        },
      });
    }
  }

  getProgram($event: ProgramListDto | ProgramClientListDto) {
    if ($event && "programName" in $event) {
      this.programName = $event.programName;
      this.customerAccountNumber = $event.clientAccount;
      this.programDetailsEvent.emit($event);
    }
  }

  // disableBuyerFeild(status: boolean){
  //   if(status){
  //     this.parent.get(['orderHeader', 'buyer'])?.disable();
  //   }
  //   else{
  //     this.parent.get(['orderHeader', 'buyer'])?.enable();
  //   }
  // }

  patchValueInCurrencyFieldEvent(currency: string) {
    if (this.newSalesOrderCase) {
      this.patchValueInCurrencyField.emit(currency);
    }
  }

  loadInventoryLookups() {
    this.parent
      .get(["orderDetails", "store"])
      ?.setValidators(Validators.required);
    this.parent.get(["orderDetails", "store"])?.updateValueAndValidity();
    this.parent
      .get(["orderDetails", "warehouse"])
      ?.setValidators(Validators.required);
    this.parent.get(["orderDetails", "warehouse"])?.updateValueAndValidity();

    this._inventoryLookupService
      .getStores()
      .pipe(untilDestroyed(this))
      .subscribe(res => {
        this.storeList = res.data ?? [];
      });
    this._inventoryLookupService
      .getWarehouses()
      .pipe(untilDestroyed(this))
      .subscribe(res => {
        this.warehouseList = (res.data ?? []).filter(
          w => w.inventoryWarehouseD365 === "Yes"
        );
      });
  }

  onStoreChange() {
    this.refreshOwners();
  }

  onWarehouseChange(warehouseId: string) {
    if (warehouseId) {
      this._inventoryLookupService
        .getSiteByWarehouse(warehouseId)
        .pipe(untilDestroyed(this))
        .subscribe(res => {
          this.parent.patchValue({ orderDetails: { site: res.data ?? "" } });
        });
    } else {
      this.parent.patchValue({ orderDetails: { site: "" } });
    }
    this.refreshOwners();
  }

  refreshOwners() {
    const store = this.parent.get("orderDetails.store")?.value as string;
    const warehouse = this.parent.get("orderDetails.warehouse")
      ?.value as string;
    if (store && warehouse) {
      this.ownerDisabled = false;
      this._inventoryLookupService
        .getOwnersByStoreAndWarehouse(store, warehouse)
        .pipe(untilDestroyed(this))
        .subscribe(res => {
          this.ownerList = res.data ?? [];
          const currentOwner = this.parent.get("orderDetails.owner")?.value;
          if (
            currentOwner &&
            !this.ownerList.some(o => o.ownerD365 === currentOwner)
          ) {
            this.ownerList = [{ ownerD365: currentOwner }, ...this.ownerList];
          }
        });
    } else {
      this.ownerDisabled = true;
      this.ownerList = [];
      this.parent.patchValue({ orderDetails: { owner: null } });
    }
  }

  onInventoryCustomerDefaults(defaults: {
    storeD365?: string | null;
    warehouseD365?: string | null;
    ownerD365?: string | null;
  }) {
    if (defaults.storeD365) {
      this.parent.patchValue({ orderDetails: { store: defaults.storeD365 } });
    }
    if (defaults.warehouseD365) {
      this.parent.patchValue({
        orderDetails: { warehouse: defaults.warehouseD365 },
      });
      this.onWarehouseChange(defaults.warehouseD365);
    }
    if (defaults.ownerD365) {
      this.parent.patchValue({ orderDetails: { owner: defaults.ownerD365 } });
    }
  }
}
